import React, { useRef, useState, useEffect } from "react";
import { render } from "react-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";

(function init() {
  const selectors = {
    root: "[data-reviews-slideshow]",
  };

  function loadComponent() {
    const rootElement = document.querySelector(selectors.root);
    if (rootElement) render(<ReviewsSlideshow />, rootElement);
  }

  document.addEventListener("shopify:section:load", loadComponent);
  loadComponent();
})();

function ToggleText(props) {
  const [toggle, setToggle] = useState(false);
  return (
    <p>
      <span style={{ display: toggle ? "none" : "inline" }}>
        {props.displayText.slice(0, 200)}
      </span>
      <span style={{ display: toggle ? "inline" : "none" }}>
        {props.displayText}
      </span>
      <span onClick={() => setToggle(!toggle)}>
        <span style={{ display: toggle ? "none" : "inline" }}>
          ... <span class="underline">(read more)</span>
        </span>
        <span style={{ display: toggle ? "inline" : "none" }}>
          <br />
          <span class="underline">Click to collapse</span>
        </span>
      </span>
    </p>
  );
}
function ReviewPoP(props) {
  const readMoreHandler = (e) => {
    props.setShowModal(true);
    props.setSelectedReview(props.review);
    document.getElementById("bodyBackground").classList.remove("hidden")
    document.getElementById("reviewBackground").classList.remove("hidden")
    let ratingStarTypes = [];
    Array.apply(null, { length: 5 }).map((e, i) => {
      const current = i + 1;
      const prev = current - 1;
      if (props.review.rating >= current) {
        ratingStarTypes.push("full");
      } else {
        props.review.rating < current && props.review.ating > prev
          ? ratingStarTypes.push("half")
          : ratingStarTypes.push("empty");
      }
    });
    props.setSelectedRatingStarTypes(ratingStarTypes);
  };

  return (
    <>
      <div>
        <span style={{ display: "inline" }}>
          {props.displayText.slice(0, 200)}
        </span>
        <span style={{ display: "inline" }}>
          ...{" "}
          <button className="underline" type="button" onClick={readMoreHandler}>
            (read more)
          </button>
        </span>
      </div>
    </>
  );
}

function ReviewsSlideshow() {
  const reviews = JSON.parse(
    document.querySelector("[data-reviews]").innerHTML
  );
  const swiper = useRef(null);
  const maxReviewLength = 200;
  const [showModal, setShowModal] = useState(false);
  const [selectedReview, setSelectedReview] = useState({
    image: null,
    image_alt: null,
    text: null,
    author: null,
    wig: null,
    rating: null,
  });
  const [selectedRatingStarTypes, setSelectedRatingStarTypes] = useState([]);
  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 640) {
      setMobile(true);
    }
  }, [mobile]);

  return (
    <div className="relative px-[3rem]">

      <button
        className="absolute w-[3rem] h-[3rem] top-[50%] -translate-y-2/4 left-0 xl:-left-[0.5rem] z-10 flex justify-center items-center"
        onClick={() => swiper.current.swiper.slidePrev()}
      >
        <svg
          width="10"
          height="16"
          viewBox="0 0 10 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.021 0.824463L1.52099 7.79848L9.02099 14.7725"
            stroke="black"
            stroke-width="2"
          />
        </svg>
      </button>
      <button
        className="absolute w-[3rem] h-[3rem] top-[50%] -translate-y-2/4 right-0  xl:-right-[0.5rem] z-10 flex justify-center items-center"
        onClick={() => swiper.current.swiper.slideNext()}
      >
        <svg
          width="10"
          height="16"
          viewBox="0 0 10 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.979004 15.2737L8.47901 8.29967L0.979006 1.32565"
            stroke="black"
            stroke-width="2"
          />
        </svg>
      </button>
      <div className="relative z-0">
      <div id="reviewBackground"  className="hidden opacity-60 bg-neutral-900 fixed w-full h-full top-0 left-0 z-10 ">
      </div>  
        <div className="overflow-hidden relative mt-[2.25rem] md:mt-[3rem]">
          <Swiper
            ref={swiper}
            loop={false}
            modules={[Pagination]}
            slidesPerView={1}
            spaceBetween={16}
            breakpoints={{
              1200: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 3,
              },
              768: {
                slidesPerView: 2,
              },
            }}
            className="swiper swiper--full-height"
          >
            {reviews.map((review, review_index) => {
              const rating = review.rating;
              let ratingStarTypes = [];
              let reviewText = "";
              function toggleReviewText() {
                document.getElementById(
                  "review-text-" + review_index
                ).innerHTML = "NEWTEXT";
                console.log(
                  document.getElementById("review-text-" + review_index)
                );
              }

              Array.apply(null, { length: 5 }).map((e, i) => {
                const current = i + 1;
                const prev = current - 1;
                if (rating >= current) {
                  ratingStarTypes.push("full");
                } else {
                  rating < current && rating > prev
                    ? ratingStarTypes.push("half")
                    : ratingStarTypes.push("empty");
                }
              });

              return (
                <SwiperSlide className="rounded-xl overflow-hidden bg-white">
                  <article className="h-full flex flex-col relative">
                    <img
                      src={review.image}
                      alt={review.image_alt}
                      className="h-full"
                      />
                    <div className="p-[1.5rem] flex flex-col h-full">
                      <blockquote>
                        <cite className="text-[1rem] font-medium not-italic block mb-[0.25rem]">
                          {review.author}
                        </cite>
                        <p className="text-xs font-medium not-italic block">
                         
                          {review.wig}
                        </p>
                        <div className="text-sm font-medium leading-6 text-gray-900 mt-[0.75rem] rte">
                          {mobile ? (
                            review.text.length > maxReviewLength ? (
                              <ToggleText
                                displayText={review.text.slice(3, -4)}
                              />
                            ) : (
                              review.text.slice(3, -4)
                            )
                          ) : null}
                          {!mobile ? (
                            review.text.length > maxReviewLength ? (
                              <ReviewPoP
                                displayText={review.text.slice(3, -4)}
                                setShowModal={setShowModal}
                                review={review}
                                setSelectedReview={setSelectedReview}
                                setSelectedRatingStarTypes={
                                  setSelectedRatingStarTypes
                                }
                              />
                            ) : (
                              review.text.slice(3, -4)
                            )
                          ) : null}
                        </div>
                      </blockquote>

                      <div className="mt-[1.25rem] mb-[0.25rem] flex gap-x-[0.25rem]">
                        <span className="sr-only">
                          Customer rating: {review.rating} out of 5 stars
                        </span>
                        {ratingStarTypes.map((star) => {
                          return (
                            <svg
                              aria-hidden="true"
                              aria-focusable="false"
                              width="20"
                              height="19"
                              viewBox="0 0 20 19"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <use xlinkHref={`#icon-star-${star}`}></use>
                            </svg>
                          );
                        })}
                      </div>
                    </div>
                  </article>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
        {showModal ? (
          <div className="absolute inset-0 flex shrink-0 bg-white z-10 w-[95%] m-auto">
            <div className="w-2/4">
              <img
                src={selectedReview.image}
                alt={selectedReview.image_alt}
                className="h-full aspect-[1/1] object-cover"
              />
            </div>
            <div className="pt-8 w-2/4 pl-2">
              <button
                type="button"
                className="absolute right-0 pr-2 bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                onClick={() => {
                  setShowModal(false);
                  document.getElementById("bodyBackground").classList.add("hidden")
                  document.getElementById("reviewBackground").classList.add("hidden")
                }}
              >
                <span className="sr-only">Close menu</span>
                <svg
                  className="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
              <div className="mt-16">
                <p className="text-sm font-bold not-italic block mb-2">
                  {selectedReview.author}
                </p>
                <p className="text-sm font-bold not-italic block mb-2 ">
                  {selectedReview.wig}
                </p>
                <p className="text-sm font-bold leading-6 rte mb-2 overflow-y-auto h-auto max-h-64">
                  {selectedReview.text.slice(3, -4)}
                </p>
              </div>
              <div className="mt-[1.25rem] mb-[0.25rem] flex gap-x-[0.25rem]">
                <span className="sr-only">
                  Customer rating: {selectedReview.rating} out of 5 stars
                </span>
                {selectedRatingStarTypes.map((star) => {
                  return (
                    <svg
                      aria-hidden="true"
                      aria-focusable="false"
                      width="20"
                      height="19"
                      viewBox="0 0 20 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <use xlinkHref={`#icon-star-${star}`}></use>
                    </svg>
                  );
                })}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}